import entityBase from "entityBase";
import * as ko from "knockout";
import { CustomObservables } from "CustomObservables";

export class meter_reading_type extends entityBase {
  last_counter: KnockoutObservable<string>;
  last_counter_dt: KnockoutObservable<Date>;
  last_counter_dttm: KnockoutObservable<any>;
  counter: KnockoutObservable<string>;

  constructor(item: any) {
    super();
    this.counter = ko.observable(item.counter).extend({ maxLength: 128 });
    this.last_counter = ko.observable(item.last_counter).extend({ maxLength: 128 });
    this.last_counter_dt = ko.observable(this.formatJSONDate(item.last_counter_dttm));
    this.last_counter_dttm = CustomObservables.formattedDateTimeObservable(this.last_counter_dt);
  }
}
